module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/babel-loader/lib/index.js??ref--4-0!./index.js"));
	}, "customercatalogfavouritespage");
}